import type { PriceGridFilterState } from './types';

const SHOW_LEG_MARKET_SELECTOR_KEY = 'showLegMarketSelector';

export function getShowLegMarketSelector(filterState: PriceGridFilterState) {
  return filterState.custom?.[SHOW_LEG_MARKET_SELECTOR_KEY] !== false;
}

export function setShowLegMarketSelector(filterState: PriceGridFilterState, enabled: boolean) {
  return {
    ...filterState,
    custom: {
      ...filterState.custom,
      [SHOW_LEG_MARKET_SELECTOR_KEY]: enabled ? undefined : false,
    },
  };
}
